firebird.factory('videoConnectivityService', [
    '$window',
    '$timeout',
    '$interval',
    'logService',
    'configService',
    'connectivityService',
    'avDeviceService',
    'phoneConferenceService',
    'analyticsWrapperService',
    'helperService',
    'meetingService',
    'executionEnvironmentEnum',
    'videoGlobalService',
    function (
        $window,
        $timeout,
        $interval,
        logService,
        configService,
        connectivityService,
        avDeviceService,
        phoneConferenceService,
        analyticsWrapperService,
        helperService,
        meetingService,
        executionEnvironmentEnum,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoConnectivityService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            logger.log('initialize', 'Initializing videoConnectivityService with selfParam:', selfParam);
            self.initConnectivity = initConnectivity;

            // state for connectivity check with external service.
            // this data and code should be moved to connectivityService or elsewhere. It should also include some form of UDP test.
            self.checkConn = {
                timeout: 10000,
                timer: null,
                xhr1: null,
                status1: null,
                start1: 0,
                end1: 0,
                xhr2: null,
                status2: null,
                start2: 0,
                end2: 0,
                callbacks: [] // pending callbacks in checkConnectivity
            };

            self.checkConnectivity = checkConnectivity;
            self.stopCheckConnectivity = stopCheckConnectivity;
            self.logCheckConnectivityResult = logCheckConnectivityResult;

            // whether to periodically check connectivity with external server, and log in FireFly.
            self.periodicConnCheck = {
                enabled: true,
                interval: 30000, // in ms
                abortTimeout: 10000, // in ms
                timer: null,
                xhr2: null,
                status2: null,
                start2: 0,
                end2: 0,
                delay: undefined // or time in ms.
            };

            self.startPeriodicConnCheckTimer = startPeriodicConnCheckTimer;
            self.stopPeriodicConnCheckTimer = stopPeriodicConnCheckTimer;

            // capture various times for metrics: call setup latency, disconnect duration, and others.
            self.connTimeData = {
                // following are bool unless indicated as time for timestamp

                enabled: true,

                appStart: $window._appStartTime || undefined, // time from app.js
                modInit: Date.now(), // time of this module init
                waitTime: undefined, // non-meeting page wait delays
                startTime: undefined, // will be either modInit, or appStart + non-meeting page wait delays.
                sleepTime: undefined, // system sleep time, If any.
                sleepTimes: [], // {start, end, duration}
                sleepInterval: 2000, // interval to detect sleep, ms
                sleepDetectTimer: null,

                network: true, // assume connected initially
                nodeSocket: true, // assume connected initially
                mediaSocket: undefined,
                fsConnect: undefined,

                audioInput: true, // if false, then not used, e.g., switch to phone or disconnected device.
                voiceCallMedia: undefined,
                voiceCallConnect: undefined,
                voiceCallIce: undefined,

                videoButton: undefined, // button pressed
                videoStart: undefined, // time of last button press to on
                videoStop: undefined, // time of disconnect while the button is still on
                videoSetup: undefined, // time for video tx setup delay
                videoPublish: undefined,
                videoMedia: undefined, // may be a number 1, 2, 3 for substreams, and 0 is same as undefined.
                videoConnect: undefined,
                videoIce: undefined,
                videoVbgLoad: undefined, // virtual background loading status

                screenButton: undefined,
                screenStart: undefined,
                screenStop: undefined,
                screenSetup: undefined,
                screenPublish: undefined,
                screenMedia: undefined,
                screenConnect: undefined,
                screenIce: undefined,

                connect: undefined, // time of last connect
                disconnect: undefined, // time of last disconnect
                count: undefined, // number of times reconnected
                reason: undefined, // node or media or comma separated.

                joinFlow: undefined, // wait time for join flow
                screenSelect: undefined, // wait time for screen share selection
                callSetup: undefined, // calculated time - call setup delay
                pageLoad: undefined, // client load time
                joinTime: undefined, // actual call join time = call setup - page load

                events: [], // each item is {type, ts}
                stats: null // pending stats data to send
            };

            self.updateConnTimeDevice = updateConnTimeDevice;
            self.updateConnTimeData = updateConnTimeData;
            self.addConnectivityMetric = addConnectivityMetric;
            self.startSleepDetectTimer = startSleepDetectTimer;
            self.cancelSleepDetectTimer = cancelSleepDetectTimer;
            self.validateCallSetup = validateCallSetup;
            self.adjustJoinFlowForSleep = adjustJoinFlowForSleep;

            self.logBuffer = [];

            self.startSleepDetectTimer();

            // Listen for VBG loading event
            $scope.$on('vbg-loading', (event, phase) => {
                self.updateConnTimeData('videoVbgLoad', phase === 'start');
            });
        }

        function initConnectivity() {
            const data = self.connTimeData;
            data.enabled = configService.getValue('connTimeData') !== 'false';

            if (data.enabled) {
                data.events.push({ name: 'moduleInit', value: true, ts: data.modInit });
                if (meetingService._durationTestrtc) {
                    const { start, end } = meetingService._durationTestrtc;
                    meetingService._durationTestrtc = null;
                    data.events.push({ name: 'testrtc', value: true, ts: start });
                    data.events.push({ name: 'testrtc', value: false, ts: end });
                    data.testrtc = end - start;
                }

                if ($window._appStateChanges && $window._appStateChanges.length) {
                    const t0 = $window._appStateChanges[0].ts;
                    const t1 = $window._appStateChanges.find(
                        item => item.to && item.to.indexOf('meeting-active') > -1
                    )?.ts;
                    const t2 = $window._appStateChanges.find(item => item.to == 'loading')?.ts;
                    const t3 = $window._appStateChanges.find(
                        item => item.to == 'meeting-locked-waiting-for-approval'
                    )?.ts;
                    const t4 = $window._appStateChanges.find(
                        item => item.from == 'meeting-locked-waiting-for-approval'
                    )?.ts;

                    const t5 = $window._appStateChanges.find(item => item.to == 'meeting-show-electron')?.ts;
                    const t6 = $window._appStateChanges.find(item => item.from == 'meeting-show-electron')?.ts;

                    // count until first of loading or meeting-active.
                    if ((t2 || t1) && t0) {
                        let waitTime = (t2 || t1) - t0 + (t3 && t4 ? t4 - t3 : 0);
                        if (t5 && t6) {
                            // meeting-show-electron is not counted in wait time.
                            waitTime = Math.max(0, waitTime - (t6 - t5));
                        }
                        if (waitTime > 1000) {
                            // ignore if no real wait happened.
                            data.waitTime = waitTime;
                        }
                    }
                    logger.log(
                        'initConnectivity',
                        'wait time ' + data.waitTime + ' state changes=' + JSON.stringify($window._appStateChanges)
                    );
                }
                data.startTime = !data.appStart ? data.modInit : data.appStart + (data.waitTime || 0);
                data.pageLoad = !data.appStart
                    ? undefined
                    : Math.max(0, data.modInit - data.appStart - (data.waitTime || 0));
                logger.log('initConnectivity', 'page load in ' + data.pageLoad + ' ms');
            }

            configService.setConfigObjectFromName(self.periodicConnCheck, 'periodicConnCheck', { default: true });
        }

        function startSleepDetectTimer() {
            const data = self.connTimeData;
            if (!data.sleepInterval) {
                logger.log('startSleepDetectTimer', 'Sleep interval not set. Exiting.');
                return;
            }
            self.cancelSleepDetectTimer();
            let lastTime = Date.now();
            logger.log('startSleepDetectTimer', 'Sleep time detection started');
            const sleepInterval = parseInt(data.sleepInterval) || 2000;
            data.sleepDetectTimer = $interval(function () {
                if (data.callSetup) {
                    // Call setup is done, clear sleep detect interval
                    logger.log('startSleepDetectTimer', 'Call setup complete. Cancelling sleep detection timer.');
                    self.cancelSleepDetectTimer();
                } else {
                    const now = Date.now();
                    if (now > lastTime + sleepInterval * 2) {
                        // ignore small delays
                        const sleepStart = lastTime + sleepInterval * 2;
                        const sleepTime = Math.max(0, now - sleepStart);
                        data.sleepTimes.push({ start: sleepStart, end: now, duration: sleepTime });
                        self.updateConnTimeData('sleepTime', sleepTime);
                        logger.log('startSleepDetectTimer', 'Sleep time detected ' + sleepTime + ' ms');
                    }
                    lastTime = now;
                }
            }, sleepInterval);
        }

        function cancelSleepDetectTimer() {
            const data = self.connTimeData;
            if (data.sleepDetectTimer) {
                $interval.cancel(data.sleepDetectTimer);
                data.sleepDetectTimer = null;
                logger.log('cancelSleepDetectTimer', 'Sleep detection timer cancelled.');
            }
        }

        function validateCallSetup(data, now) {
            const min30 = 30 * 60 * 1000; // 30min in ms.
            if (data.callSetup < -min30 || data.callSetup > min30) {
                logger.warn(
                    'validateCallSetup',
                    `invalid callsetup due to possible clock change, resetting metrics. ` +
                        `startTime=${data.startTime} joinFlow=${data.joinFlow} ` +
                        `pageLoad=${data.pageLoad} sleepTime=${data.sleepTime} ` +
                        `callSetup=${data.callSetup}`
                );
                data.callSetup = data.pageLoad = data.joinFlow = data.sleepTime = 0;
                data.startTime = now;
            }

            if (data.callSetup < 0) {
                logger.warn(
                    'validateCallSetup',
                    `negative callsetup, resetting to 0, and reducing joinFlow or sleepTime by ${-data.callSetup}ms. ` +
                        `startTime=${data.startTime} joinFlow=${data.joinFlow} ` +
                        `pageLoad=${data.pageLoad} sleepTime=${data.sleepTime} ` +
                        `callSetup=${data.callSetup}`
                );
                if (data.joinFlow > 0) {
                    data.joinFlow = Math.max(0, data.joinFlow + data.callSetup);
                } else if (data.sleepTime > 0) {
                    data.sleepTime = Math.max(0, data.sleepTime + data.callSetup);
                }
                data.callSetup = 0;
            }
        }

        function startPeriodicConnCheckTimer() {
            const config = self.periodicConnCheck;
            if (config.enabled && !config.timer && config.interval > 0) {
                const handler = () => {
                    if (!config.xhr2) {
                        config.status2 = null;
                        config.start2 = Date.now();
                        config.end2 = 0;

                        if (config.abortTimeout > 0) {
                            config.abortTimer = $timeout(() => {
                                config.abortTimer = null;
                                // status2 remains null.
                                config.end2 = Date.now();
                                config.delay = config.end2 - config.start2;
                                logger.log(
                                    'startPeriodicConnCheckTimer',
                                    `aborting on timeout, delay=${config.delay}ms`
                                );
                                if (config.xhr2) {
                                    var xhr2 = config.xhr2;
                                    config.xhr2 = null;
                                    xhr2.abort();
                                }
                            }, config.abortTimeout);
                        }

                        var xhr2 = (config.xhr2 = new XMLHttpRequest());
                        xhr2.onload = xhr2.onerror = function (event) {
                            if (config.abortTimer) {
                                $timeout.cancel(config.abortTimer);
                                config.abortTimer = null;
                            }
                            if (config.xhr2) {
                                config.status2 = event.type;
                                config.xhr2 = null;
                                if (config.start2) {
                                    config.end2 = Date.now();
                                    config.delay = config.end2 - config.start2;
                                    logger.debug('startPeriodicConnCheckTimer', `delay=${config.delay}ms`);
                                }
                            }
                        };
                        // this will always fail, but from server.
                        var extUrl = 'https://www.google.com/?r=' + ('' + Math.random()).substring(2, 14);
                        xhr2.open('GET', extUrl);
                        xhr2.send();
                    } else {
                        logger.log('startPeriodicConnCheckTimer', 'ignored, as waiting for previous response');
                        if (config.start2) {
                            config.end2 = config.ts = Date.now();
                            config.delay = config.end2 - config.start2;
                            logger.debug('startPeriodicConnCheckTimer', `delay=${config.delay}ms`);
                        }
                    }
                };

                logger.log('startPeriodicConnCheckTimer', `interval=${config.interval}`);
                handler(); // invoke first time now, before periodic timer.
                config.timer = $interval(handler, config.interval);
            }
        }

        function stopPeriodicConnCheckTimer() {
            const config = self.periodicConnCheck;
            if (config.enabled) {
                if (config.abortTimer) {
                    $timeout.cancel(config.abortTimer);
                    config.abortTimer = null;
                }
                if (config.timer) {
                    logger.log('stopPeriodicConnCheckTimer', 'called');
                    $interval.cancel(config.timer);
                    config.timer = null;
                }
            }
        }

        // check if we are disconnected from Internet by checking Ajax to our media server as well as external third-party web server.
        // if timeout is supplied in milliseconds, that is used. otherwise defaults to 10s.
        // callback if supplied is invoked with connectivity status (true or false).
        function checkConnectivity(reason, timeout, callback) {
            logger.log(
                'checkConnectivity',
                'Connectivity check initiated with reason: ' +
                    reason +
                    ', timeout: ' +
                    (timeout || self.checkConn.timeout)
            );
            // allow reentrant call, store callbacks, and invoke them when done.
            if (callback) {
                self.checkConn.callbacks.push(callback);
            }
            var invokeCallback = function (value) {
                var callbacks = self.checkConn.callbacks.splice(0, self.checkConn.callbacks.length);
                callbacks.forEach(function (callback) {
                    callback(value);
                });
            };

            if (!self.checkConn.timer && !self.checkConn.xhr1 && !self.checkConn.xhr2) {
                logger.log('checkConnectivity', 'check connectivity scheduled because of', reason);

                // timer used to avoid interrupting or delaying the caller callback function
                self.checkConn.timer = $timeout(function () {
                    var serverHost = phoneConferenceService.getPhoneData().server;

                    self.checkConn.start1 = self.checkConn.start2 = Date.now();
                    self.checkConn.end1 = self.checkConn.end2 = 0;
                    self.checkConn.status1 = self.checkConn.status2 = null;

                    self.checkConn.timer = $timeout(function () {
                        self.checkConn.timer = null;
                        logger.log(
                            'checkConnectivity',
                            'Connectivity check initiated with serverHost: ' +
                                serverHost +
                                ', reason: ' +
                                reason +
                                ', timeout: ' +
                                (timeout || self.checkConn.timeout)
                        );
                        self.logCheckConnectivityResult(serverHost, 'timeout', reason);
                        self.stopCheckConnectivity(true); // abort pending
                        invokeCallback(false);
                    }, timeout || self.checkConn.timeout); // limit to 10 seconds for connectivity check

                    var handler = function () {
                        if (self.checkConn.status1 && self.checkConn.status2) {
                            if (self.checkConn.timer) {
                                $timeout.cancel(self.checkConn.timer);
                                self.checkConn.timer = null;
                            }
                            self.logCheckConnectivityResult(serverHost, undefined, reason);
                            invokeCallback(true);
                        }
                    };

                    var xhr1 = (self.checkConn.xhr1 = new XMLHttpRequest());
                    xhr1.onload = xhr1.onerror = function (event) {
                        if (self.checkConn.xhr1) {
                            self.checkConn.status1 = event.type;
                            self.checkConn.end1 = Date.now();
                            self.checkConn.xhr1 = null;
                            handler();
                        }
                    };
                    var uploadUrl = 'https://' + serverHost + '/speedtest.bin?n=' + ('' + Math.random()).substr(2, 20);
                    xhr1.open('POST', uploadUrl);
                    xhr1.withCredentials = true;
                    xhr1.send('check');

                    var xhr2 = (self.checkConn.xhr2 = new XMLHttpRequest());
                    xhr2.onload = xhr2.onerror = function (event) {
                        if (self.checkConn.xhr2) {
                            self.checkConn.status2 = event.type;
                            self.checkConn.end2 = Date.now();
                            self.checkConn.xhr2 = null;
                            handler();
                        }
                    };
                    // this will always fail, but from server.
                    var extUrl = 'https://www.google.com/?r=' + ('' + Math.random()).substr(2, 10);
                    xhr2.open('GET', extUrl);
                    xhr2.send();
                }, 0);
            } else {
                logger.log('videoroomCtrl checkConnectivity not scheduled');
            }
        }

        function stopCheckConnectivity(keepCallbacks) {
            logger.log('stopCheckConnectivity', 'Stopping connectivity check. keepCallbacks:', keepCallbacks);
            if (self.checkConn.timer) {
                $timeout.cancel(self.checkConn.timer);
                self.checkConn.timer = null;
            }
            if (self.checkConn.xhr1) {
                var xhr1 = self.checkConn.xhr1;
                self.checkConn.xhr1 = null;
                xhr1.abort();
            }
            if (self.checkConn.xhr2) {
                var xhr2 = self.checkConn.xhr2;
                self.checkConn.xhr2 = null;
                xhr2.abort();
            }
            if (!keepCallbacks && self.checkConn.callbacks.length > 0) {
                self.checkConn.callbacks.splice(0, self.checkConn.callbacks.length);
                logger.log('stopCheckConnectivity', 'Cleared pending callbacks.');
            }
        }

        function logCheckConnectivityResult(server, type, reason) {
            var time1 = (self.checkConn.end1 || undefined) - self.checkConn.start1;
            var time2 = (self.checkConn.end2 || undefined) - self.checkConn.start2;

            var logMessage = `checkConnectivity ${type || 'completed'} result=${self.checkConn.status1}/${
                self.checkConn.status2
            } time=${time1}/${time2} reason=${reason}`;
            logger.log('logCheckConnectivityResult', logMessage);

            if (self.checkConn.status1 === 'error' || self.checkConn.status2 === 'error') {
                self.logBuffer.push(
                    logMessage +
                        ' | Server: ' +
                        server +
                        ' | Server Status: ' +
                        self.checkConn.status1 +
                        ' | Internet Status: ' +
                        self.checkConn.status2 +
                        ' | Local Time: ' +
                        new Date().toLocaleString()
                );
            }

            var value1 = {
                status1: self.checkConn.status1 || '0',
                status2: self.checkConn.status2 || '0',
                time1: isNaN(time1) ? 'NaN' : time1,
                time2: isNaN(time2) ? 'NaN' : time2,
                reason: reason
            };
            self.msgflowEvent('connectivity ' + (type || 'check'), value1);

            if (
                reason !== 'networkCollectMoreStatsAfter' ||
                type === 'timeout' ||
                Math.max(time1, time2) > self.networkState.moreStats.connectivityDelayThreshold
            ) {
                // need copy of value1 since analytics modifies its attributes.
                var value2 = Object.assign({ sfuEvent: true, server: (server || '').split('.')[0] }, value1);
                analyticsWrapperService.eventTrack(
                    'Meeting - connectivity ' +
                        (type || 'check') +
                        ' - ' +
                        (isNaN(time2) ? 'failed internet' : isNaN(time1) ? 'failed server' : 'success'),
                    value2
                );
            }
        }

        function updateConnTimeDevice() {
            const active =
                !connectivityService.getAudioThroughPhone() &&
                !avDeviceService.isAudioDisconnected() &&
                avDeviceService.hasMicrophone() &&
                avDeviceService.getDevicePermissions().audioAllowed;
            self.updateConnTimeData('audioInput', active);
        }

        function adjustJoinFlowForSleep(now, extra) {
            const data = self.connTimeData;
            // Find join flow start and end events
            const joinFlowStart = data.events.filter(event => event.name == 'joinFlow' && event.value);
            const joinFlowEnd = data.events.filter(event => event.name == 'joinFlow' && !event.value);

            if (joinFlowStart.length && joinFlowStart.length === joinFlowEnd.length) {
                const sleepStart = now - extra;
                const sleepEnd = now;

                joinFlowStart.forEach((startEvent, index) => {
                    const endEvent = joinFlowEnd[index];
                    const joinStart = startEvent.ts;
                    const joinEnd = endEvent.ts;

                    // Check if join flow overlaps with sleep time
                    if (joinStart < sleepEnd && joinEnd > sleepStart) {
                        // Calculate overlap
                        const overlapStart = Math.max(joinStart, sleepStart);
                        const overlapEnd = Math.min(joinEnd, sleepEnd);
                        const overlapTime = Math.max(0, overlapEnd - overlapStart);

                        // Adjust the join flow start time to account for the overlap
                        if (overlapTime > 0) {
                            const adjustedJoinDuration = Math.max(0, joinEnd - joinStart - overlapTime);
                            startEvent.ts = joinEnd - adjustedJoinDuration;
                            logger.log(
                                'updateConnTimeData',
                                `Adjusted join flow timestamps due to sleep time overlap: ${overlapTime}ms removed. ` +
                                    `Join flow: ${joinStart}-${joinEnd}, Sleep: ${sleepStart}-${sleepEnd}, ` +
                                    `Join start changed: ${joinStart} to ${startEvent.ts}`
                            );
                        }
                    }
                });
            }
        }

        function getVbgLoadEvents(events) {
            const vbgLoadEvents = events.filter(e => e.name === 'videoVbgLoad');
            const vbgStart = vbgLoadEvents.find(e => e.value === true);
            const vbgEnd = vbgLoadEvents.find(e => e.value === false);

            // Calculate vbgLoadTime: -1 if in progress, 0 if not started or invalid, positive if completed
            let vbgLoadTime = 0;
            if (vbgStart) {
                if (!vbgEnd || vbgEnd.ts <= vbgStart.ts) {
                    vbgLoadTime = -1; // In progress
                } else {
                    vbgLoadTime = vbgEnd.ts - vbgStart.ts; // Completed
                }
            }

            return { vbgStart, vbgEnd, vbgLoadTime };
        }

        function updateConnTimeData(name, extra) {
            const data = self.connTimeData;
            if (!data.enabled && name != 'joinFlow' && name != 'audioInput') {
                logger.log('updateConnTimeData', 'Data not enabled for event:', name);
                return;
            }

            const now = Date.now();

            if (name == 'joinFlow' || name == 'screenSelect' || name == 'sleepTime') {
                let duration = extra;
                if (name == 'joinFlow') {
                    // Remove sleep overlap time from join flow
                    const joinStart = now - extra;
                    const joinEnd = now;
                    data.sleepTimes.forEach(sleepTime => {
                        const sleepStart = sleepTime.start;
                        const sleepEnd = sleepTime.end;
                        if (joinStart < sleepEnd && joinEnd > sleepStart) {
                            const overlapStart = Math.max(joinStart, sleepStart);
                            const overlapEnd = Math.min(joinEnd, sleepEnd);
                            const overlapTime = Math.max(0, overlapEnd - overlapStart);
                            duration = Math.max(0, duration - overlapTime);
                        }
                    });
                } else if (name == 'sleepTime') {
                    // Remove this specific sleep overlap time from join flow
                    self.adjustJoinFlowForSleep(now, extra);
                }

                data[name] =
                    name == 'sleepTime'
                        ? data.sleepTimes.reduce((total, sleepTime) => total + sleepTime.duration, 0)
                        : duration;
                data.events.push({ name, value: true, ts: now - duration }, { name, value: false, ts: now });
                if (!data.enabled) {
                    return;
                }
            } else if (name == 'audioInput' && !data.enabled) {
                const old = data[name];
                if (old !== extra) {
                    data[name] = extra;
                    data.events.push({ name, value: extra, ts: now });
                }
                return;
            } else if (name == 'videoMedia') {
                // need to count
                data[name] = Math.min(3, Math.max(0, (data[name] || 0) + (extra ? 1 : -1))); // minimum 0, max 3
                data.events.push({ name, value: extra, ts: now });
            } else {
                if (name in data) {
                    const old = data[name]; // may be undefined, false or true
                    if (old !== extra) {
                        data[name] = extra;
                        data.events.push({ name, value: extra, ts: now });
                    } else {
                        // no change
                        return;
                    }
                }
                // reset some state
                if (!extra) {
                    if (name == 'screenPublish') {
                        data.screenMedia = data.screenConnect = data.screenIce = false; // will set again
                    } else if (name == 'videoPublish') {
                        data.videoConnect = data.videoIce = false; // will set again
                        data.videoMedia = 0;
                        data.videoVbgLoad = false;
                        // Clear old video events when video is stopped
                        data.events = data.events.filter(item => {
                            return !item.name.startsWith('video');
                        });
                    }
                } else {
                    if (name == 'videoButton') {
                        data.videoStart = now;
                        data.videoSetup = undefined;
                    } else if (name == 'screenButton') {
                        data.screenStart = now;
                        data.screenSetup = undefined;
                        data.screenSelect = undefined;
                    } else if (name == 'videoPublish' && !data.callSetup && !data.videoButton) {
                        data.videoButton = extra; // started from join flow
                        data.videoStart = now;
                        data.videoSetup = undefined;
                        data.events.push({ name: 'videoButton', value: extra, ts: now });
                    }
                }
            }
            const isVMware = helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.VMware;
            const connected =
                data.network &&
                data.nodeSocket &&
                data.mediaSocket &&
                (!data.audioInput || (data.fsConnect && (isVMware || data.voiceCallMedia))) &&
                data.voiceCallConnect &&
                data.voiceCallIce &&
                (!data.videoButton ||
                    !data.videoSetup ||
                    (data.videoPublish && data.videoConnect && data.videoMedia && data.videoIce)) &&
                (!data.screenButton ||
                    !data.screenSetup ||
                    (data.screenPublish && data.screenConnect && data.screenMedia && data.screenIce));

            let clear = false;

            if (data.callSetup && data.mediaSocket && extra && name == 'mediaSocket') {
                data.reason = data.reason ? data.reason + ',media' : 'media';
            }

            if (data.callSetup && data.nodeSocket && extra && name == 'nodeSocket') {
                data.reason = data.reason ? data.reason + ',node' : 'node';
            }

            if (!data.connect && connected) {
                data.connect = now;
                if (data.disconnect) {
                    data.count = (data.count || 0) + 1;
                    const duration = data.connect - data.disconnect;
                    data.disconnectDuration = (data.disconnectDuration || 0) + duration;

                    const events = data.events
                        .filter(item => item.name != 'connect')
                        .map(item => {
                            return {
                                name: item.name,
                                value: item.value,
                                ts: item.ts - data.disconnect
                            };
                        })
                        .sort((a, b) => a.ts - b.ts)
                        .map(item => {
                            return `${item.ts} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                        });

                    // Calculate VBG loading time from vbgLoad events
                    const { vbgLoadTime } = getVbgLoadEvents(data.events);

                    logger.log(
                        'updateConnTimeData',
                        'reconnected in ' +
                            duration +
                            ' ms' +
                            (vbgLoadTime > 0 ? ' (includes vbg load: ' + vbgLoadTime + ' ms)' : ''),
                        events
                    );

                    if (!data.stats) {
                        data.stats = {};
                    }
                    data.stats.disconnectActivity = Math.round(duration / 1000); // seconds
                    // const total = now - data.startTime - data.callSetup;
                    data.stats.disconnectDuration = Math.round(data.disconnectDuration / 1000);
                    // if (total > 0) {
                    //     data.stats.disconnectPercent = Math.round(data.disconnectDuration * 100000/ total) / 1000; // avoid too fine grained
                    // }
                    data.stats.disconnectCount = data.count;
                    if (data.reason) {
                        data.stats.disconnectReason = data.reason;
                        data.reason = undefined;
                    }

                    const msgflowData = {
                        start: new Date(data.disconnect).toISOString(),
                        end: new Date(data.connect).toISOString(),
                        duration,
                        events
                    };
                    if (vbgLoadTime > 0) {
                        msgflowData.vbgLoadTime = vbgLoadTime;
                    }

                    self.msgflowEvent('reconnected:' + Math.round(duration / 100) / 10, msgflowData);

                    // Clear video events after reconnect as they are stale
                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('video');
                    });
                }
                data.disconnect = undefined;
                data.events.push({ name: 'connect', value: true, ts: now });

                clear = true;
            }

            if (data.connect && !connected) {
                data.disconnect = now;
                data.connect = undefined;

                const last = data.events.pop();
                data.events = data.events.filter(item => item.name == 'connect');
                data.events.push(last);
                data.events.push({ name: 'connect', value: false, ts: now });
            }

            if (!data.callSetup && data.connect) {
                // calculate if needed
                const startTime = data.appStart || data.modInit;
                data.callSetup =
                    now - data.startTime - (data.joinFlow || 0) - (data.sleepTime || 0) - (data.testrtc || 0);
                self.validateCallSetup(data, now);
                data.joinTime = Math.max(0, data.callSetup - (data.pageLoad || 0));
                logger.log('updateConnTimeData', 'call setup in ' + data.callSetup + ' ms');
                self.cancelSleepDetectTimer();
                const events = data.events
                    .filter(item => item.name != 'connect')
                    .map(item => {
                        return { name: item.name, value: item.value, ts: item.ts - startTime };
                    })
                    .sort((a, b) => a.ts - b.ts)
                    .map(item => {
                        return `${('' + item.ts).padStart(4, ' ')} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                    });

                if (!data.stats) {
                    data.stats = {};
                }
                data.stats.callSetupDelay = Math.round(data.callSetup / 1000); // seconds
                data.stats.pageLoadDelay = Math.round(data.pageLoad / 1000);
                if (data.joinFlow) {
                    data.stats.joinFlowWait = Math.round(data.joinFlow / 1000);
                }
                const callSetup = {
                    startTime: new Date(startTime).toISOString(),
                    duration: data.callSetup,
                    pageLoad: data.pageLoad,
                    testrtc: data.testrtc,
                    joinTime: data.joinTime,
                    waitTime: data.waitTime,
                    joinFlow: data.joinFlow,
                    sleepTime: data.sleepTime,
                    events
                };
                self.msgflowEvent('call-setup:' + Math.round(data.callSetup / 100) / 10, callSetup);
                logger.log('updateConnTimeData', 'call setup data =>', callSetup);

                let joinFlowSeverity = getTimeSeverity(data.joinFlow);
                if (joinFlowSeverity) {
                    analyticsWrapperService.eventTrack(`Meeting - join flow - ${joinFlowSeverity}`, {
                        sfuEvent: true,
                        joinFlow: data.joinFlow,
                        msgflow: 'join-flow:delay'
                    });
                }
                const times = [
                    { name: 'page load', severity: getTimeSeverity(data.pageLoad), value: data.pageLoad },
                    { name: 'join time', severity: getTimeSeverity(data.joinTime), value: data.joinTime },
                    { name: '', severity: getTimeSeverity(data.callSetup), value: data.callSetup }
                ];

                // Find the first item with 'very high' or 'high' severity
                const highest =
                    times.find(({ severity }) => severity === 'very high') ||
                    times.find(({ severity }) => severity === 'high');

                if (highest) {
                    analyticsWrapperService.eventTrack(`Meeting - call setup - ${highest.severity} ${highest.name}`, {
                        sfuEvent: true,
                        value: highest.value,
                        msgflow: 'call-setup:delay'
                    });
                }
            }

            if (data.videoButton && !data.videoSetup) {
                // Get VBG loading events once
                const { vbgLoadTime } = getVbgLoadEvents(data.events);

                // Check if VBG loading is in progress (-1 means in progress, 0 means not started, positive means completed)
                const vbgLoadInProgress = vbgLoadTime === -1;

                const videoActive =
                    data.videoPublish && data.videoConnect && data.videoMedia && data.videoIce && !vbgLoadInProgress;
                if (videoActive) {
                    const startTime = data.videoStart;
                    data.videoSetup = now - startTime;

                    const events = data.events
                        .filter(item => item.name != 'connect')
                        .map(item => {
                            return { name: item.name, value: item.value, ts: item.ts - startTime };
                        })
                        .sort((a, b) => a.ts - b.ts)
                        .map(item => {
                            return `${('' + item.ts).padStart(4, ' ')} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                        });

                    logger.log(
                        'updateConnTimeData',
                        'video setup in ' +
                            data.videoSetup +
                            ' ms' +
                            (vbgLoadTime ? ' (includes vbg load: ' + vbgLoadTime + ' ms)' : ''),
                        events
                    );
                    if (!data.stats) {
                        data.stats = {};
                    }
                    data.stats.videoSetupDelay = Math.round(data.videoSetup / 1000);
                    if (vbgLoadTime > 0) {
                        data.stats.vbgLoadDelay = Math.round(vbgLoadTime / 1000);
                    }

                    const msgflowData = {
                        startTime: new Date(data.videoStart).toISOString(),
                        duration: data.videoSetup,
                        events
                    };
                    if (vbgLoadTime > 0) {
                        msgflowData.vbgLoadTime = vbgLoadTime;
                    }

                    self.msgflowEvent('video-setup:' + Math.round(data.videoSetup / 100) / 10, msgflowData);

                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('video');
                    });
                }
            }

            if (data.screenButton && !data.screenSetup) {
                const screenActive = data.screenPublish && data.screenConnect && data.screenMedia && data.screenIce;
                if (screenActive) {
                    const startTime = data.screenStart;
                    data.screenSetup = now - startTime - (data.screenSelect || 0);
                    logger.log('updateConnTimeData', 'screen setup in ' + data.screenSetup + ' ms');

                    const events = data.events
                        .filter(item => item.name != 'connect')
                        .map(item => {
                            return { name: item.name, value: item.value, ts: item.ts - startTime };
                        })
                        .sort((a, b) => a.ts - b.ts)
                        .map(item => {
                            return `${('' + item.ts).padStart(4, ' ')} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                        });

                    if (!data.stats) {
                        data.stats = {};
                    }
                    data.stats.screenSetupDelay = Math.round(data.screenSetup / 1000);
                    if (data.screenSelect) {
                        data.stats.screenSelectWait = Math.round(data.screenSelect / 1000);
                    }

                    self.msgflowEvent('screen-setup:' + Math.round(data.screenSetup / 100) / 10, {
                        startTime: new Date(data.screenStart).toISOString(),
                        duration: data.screenSetup,
                        selection: data.screenSelect,
                        events
                    });

                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('screen');
                    });
                }
            }

            // remove events no longer needed
            if (!extra) {
                if (name == 'videoButton') {
                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('video');
                    });
                } else if (name == 'screenButton') {
                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('screen');
                    });
                }
            }

            if (clear) {
                data.events = data.events.filter(item => item.name == 'connect');
            }
        }

        function getTimeSeverity(milliseconds, { high = 10000, vHigh = 30000 } = {}) {
            if (milliseconds >= vHigh) return 'very high';
            if (milliseconds >= high) return 'high';
            return '';
        }

        function addConnectivityMetric(reports) {
            const data = self.connTimeData;
            if (!data.enabled) {
                logger.log('addConnectivityMetric', 'Connectivity metrics disabled. Returning reports unchanged.');
                return reports;
            }

            const periodicConnCheck = self.periodicConnCheck;

            if (data.stats || periodicConnCheck.enabled) {
                // TODO: this can be avoided by doing "reports instanceof Array" on electron
                let newReports = [];
                reports.forEach(item => {
                    newReports.push(item);
                });

                if (newReports.length > 0 || periodicConnCheck.enabled) {
                    const oneReport = {
                        id: 'Connectivity',
                        type: 'connectivity',
                        timestamp: newReports[0].timestamp
                    };

                    let added = false;

                    if (data.stats) {
                        added = true;
                        Object.assign(oneReport, data.stats);

                        let valid = false;
                        for (let attr in data.stats) {
                            if (data.stats[attr] && typeof data.stats[attr] === 'number') {
                                valid = true;
                                data.stats[attr] = 0; // reset to 0 for next time
                            }
                        }

                        if (!valid) {
                            // no need to send anymore
                            data.stats = null;
                        }
                    }

                    if (periodicConnCheck.enabled) {
                        if (periodicConnCheck.delay && periodicConnCheck.end2) {
                            added = true;
                            periodicConnCheck.end2 = 0; // avoid re-sending same data.
                            oneReport.internetDelay = Math.round(periodicConnCheck.delay / 100) / 10;
                            oneReport.internet = periodicConnCheck.status2 ? 'connected' : 'timeout';
                        }
                    }

                    if (added) {
                        newReports.push(oneReport);

                        logger.log(
                            'addConnectivityMetric',
                            'New connectivity metric added:',
                            newReports[newReports.length - 1]
                        );
                    }

                    return newReports;
                }
            }
            return reports;
        }
    }
]);
